<style scoped>
table tr td {
  text-align: left !important;
}
table {
  text-align: left !important;
}
</style>
<template>
  <CCard>
    <CCardBody>      

      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id @change="changePageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option value="Semua Data">Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              @keyup="cariData"
              v-model="search"
            />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #no_agt="{item}">
              <td class="py-2 font-weight-bold">{{item.no_agt ? item.no_agt : "-"}}</td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2">{{item.nama_lengkap ? item.nama_lengkap : "-"}}</td>
            </template>
            <template #nama_kategori="{item}">
              <td class="py-2">{{item.nama_kategori ? item.nama_kategori : "-"}}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 " >
                <center>
                  <span
                    class="font-weight-bold text-success"
                    v-if="item.status   == 1"
                  >
                    Diterima
                  </span>
                  <span class="font-weight-bold text-danger" v-else>
                    Belum Diterima
                  </span>
                </center>
                
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <CButton v-c-tooltip="'Ubah'" color="info" square size="sm" @click="updateData(item, index)" style="margin-right:3px">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;&nbsp;
               
                <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />&nbsp;&nbsp;
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        size="lg"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body mt-n4">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="nomor_agt" class="font-weight-bold">Nomor Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nomor_agt"
                      placeholder="Terisi Otomatis"
                      
                      v-model="formData.no_anggota"
                    />
                    <input type="hidden" v-model="formData.id_asean_cpa" />
                  </div>
                  <input type="hidden" v-model="formData.id_user" />
                  <div class="form-group col-md-12">
                    <label
                      for="nama_lengkap_agt font-weight-bold"
                      class="font-weight-bold"
                    >Nama Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama_lengkap_agt"
                      placeholder="Terisi Otomatis"
                      
                      v-model="formData.nama_lengkap"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="kategori_agt" class="font-weight-bold">Nama Waiver</label>
                  <input
                    type="text"
                    class="form-control"
                    id="kategori_agt"
                    placeholder="Terisi Otomatis"
                                        
                  />
                </div>
                <div class="form-group">
                  <label for="email_agt" class="font-weight-bold">Tanggal Penerimaan</label>
                  <input
                    type="date"
                    class="form-control"
                    id="email_agt"
                    placeholder="Terisi Otomatis"
                    
                  />
                </div>
                <div class="form-group">
                  <label for="email_agt" class="font-weight-bold">Tanggal Masa Berakhir</label>
                  <input
                    type="date"
                    class="form-control"
                    id="email_agt"
                    placeholder="Terisi Otomatis"
                    
                  />
                </div>
                <div class="form-group">
                  <label for="alamat" class="font-weight-bold">Alamat</label>
                  <textarea
                    type="text"
                    class="form-control"
                    id="alamat"
                    placeholder="Terisi Otomatis"
                    
                    rows="4"
                    v-model="formData.alamat_ktp"
                  />
                </div>
                <div class="form-group" >
                  <label for="alamat" class="font-weight-bold">Dokumen Pengajuan Waiver</label>
                    <div class="custom-file text-truncate">                
                      <input 
                        type="file"
                        class="custom-file-input"
                        id="customFileLangHTML"
                        ref="uploadFileInformasiUmum"                  
                      />
                      <label
                        class="custom-file-label"
                        for="customFileLangHTML"
                        data-browse="Unggah"
                      >Upload</label>
                    </div>
                </div>
                <div class="form-group">
                    <label for="nomor_agt" class="font-weight-bold">Keterangan</label>
                    <textarea name="" v-model="formData.alasan" class="form-control" id="" cols="15" rows="4" placeholder="Masukkan Keterangan"></textarea>

                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Kirim</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import AseanCpaService from "@/services/keanggotaan/asean-cpa.service";
import DataKeanggotaanService from "@/services/keanggotaan/data-anggota.service";
import KategoriAnggotaService from "@/services/keanggotaan/kategori-anggota.service";
import WeiverService from "@/services/sertifikasi/data-weiver.service";
import { AlertUtils } from "@/mixins/AlertUtils";

const items = [
  {
    no: "1",
    no_agt: '0834374',
    nama_agt: 'Samantha Wiliam',
    tgl_penerimaan: '05-05-2020',
    tgl_expired: '05-05-2021',
    nama_waiver: 'Waiver 1',
    status: 1,    
  },
  {
    no: "2",
    no_agt: '0834374',
    nama_agt: 'Alex van Versi',
    tgl_penerimaan: '05-05-2020',
    tgl_expired: '05-05-2021',
    nama_waiver: 'Waiver 2',
    status: 0,
  },
  {
    no: "3",
    no_agt: '0834374',
    nama_agt: 'Ansu Fatti',
    tgl_penerimaan: '05-05-2020',
    tgl_expired: '05-05-2021',
    nama_waiver: 'Waiver 3',
    status: 1,
  },
  
];

const fields = [
  {
    key: "no",
    sorter: true,
    filter: true
  },
  {
    key: "no_agt",
    label: "No. Anggota",
    sorter: true,
    filter: true,
    _style: "font-weight: bold"
  },
  {
    key: "nama_agt",
    label: "Nama Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "nama_waiver",
    label: "Nama Waiver",
    sorter: true,
    filter: true
  },
  {
    key: "tgl_penerimaan",
    label: "Tanggal Penerimaan",
    sorter: true,
    filter: true
  },
  {
    key: "tgl_expired",
    label: "Tanggal Masa Berakhir",
    sorter: true,
    filter: true
  },
  
  {
    key: "status",
    label : "Status",
    _classes: 'text-center',
    sorter: true,
    filter: true
  },
  {
    key: "aksi",
    _style: "width:12.2%; text-align: center",
    sorter: true,
    filter: true
  }
];

export default {
  mixins: [AlertUtils],
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      // fieldsDokumen,
      // itemsDokumen: [],
      // items: [],
      actionPost: "",
      dataUser: [],
      search: "",
      pageSize: "",
      dataKategoriAnggota: {},
      multi_user: [
        {
          id_user: null,
          email: "",
          nama_lengkap: null,
          nama_kategori: "",
          alamat: "",
          no_anggota: ""
        }
      ],
      formData: {
        alasan : "",
        status: "",
        id_weiver: "",
        id_user: "",
        email: "",
        nama_lengkap: "",
        nama_kategori: "",
        alamat_ktp: "",
        no_anggota: "",
        nama_kategori: "",
        status_pengajuan: ""
      },
      pagination: {
        totalPages: 0
      },
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      myModalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      title: ""
    }
  },
  mounted() {
    // this.getData("0", this.pageSize, "default");
   
  },
  watch: {
    multi_user: function(val) {
      this.formData.idUser = val.id_user;
    },
    currentPage: function(val) {
      //alert val -1
      var page = val - 1;
      this.indexed = page * 10;
      this.getData(val - 1, this.pageSize, this.search);
    }
  },

  methods: {
    add_link() {

    },
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },
    filterByKategori() {
      var value = this.formData.namaKategori;
      AseanCpaService.getAseanCpa(this.currentPage, this.pageSize, value).then(
        response => {
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber;
        }
      );
    },
    cariData() {
      this.getData("0", this.pageSize, this.search);
    },
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            AseanCpaService.deleteAseanCpa(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertSuccess();
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
            Toast.fire({
              icon: "cancel",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      WeiverService.getDataWeiver(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          // this.items = response.data.data.content;
         

          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },
    getDataAnggota() {
      var vm = this;
      DataKeanggotaanService.getAllDataAnggota()
        .then(response => {
          vm.dataUser = response.data.data;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    getDataKategoriAnggota() {
      var vm = this;
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          vm.dataKategoriAnggota = response.data.data.content;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },
    createData() {
      this.myModal = true;

      this.formData = {};

      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.dataDokumen,
        canCancel: true,
        onCancel: this.onCancel
      });
      WeiverService.getDokumenWeiver(item.id_weiver)
      .then(response => {
        // this.itemsDokumen = response.data.singleData.datDokumenPengajuanWeiver;
        loader.hide()
      }).catch(error => {
        // comment console console.log(error);
      })

      // this.formData.status_pengajuan = item.status_persyaratan;
      
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("post");
      AseanCpaService.postAseanCpa(formData)
        .then(response => {
          this.myModal = false;
          this.alertSuccess();
          this.getData("0");
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log("put");
      // comment console console.log(this.formData);

      var formData = {
        statusPengajuan : this.formData.status_pengajuan,
        alasan : this.formData.alasan,
        idWeiver : this.formData.id_weiver
      }
      WeiverService.putStatusPengajuan(formData)
        .then(response => {
          loader.hide();
          // comment console console.log("ini edit data");
          this.myModal = false;
          this.alertSuccess();
          this.getData("0", this.pageSize, "default");
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>